export default "__VITE_ASSET__995b78bf__"